import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { getNegExecution } from "./index";

export const useNegExecution = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({ getNegExecution: getNegExecution(customFetch) }),
    [customFetch]
  );
};
